
const isDEV = process.env.REACT_APP_ENVIRONMENT === 'development';
const isPROD = process.env.REACT_APP_ENVIRONMENT === 'production';
const isSTG = process.env.REACT_APP_ENVIRONMENT === 'staging';
const isLOCAL = !isDEV && !isSTG && !isPROD;

export default {
    TRANSLATE_ENABLE: true,
    CREATE_TAG_GROUP_DETAIL_ENABLE: true,
    DELETE_TAG_GROUP_DETAIL_ENABLE: false,
    CAMPAIGN_ENABLED: !isPROD,
    TOUR_PROPERTIES_ENABLED: !isPROD,
    OBJECT_TYPES_ENABLED: !isPROD,
}